class BoxVideo3Col {
  render() {
    let boxVideoSocialElement = document.querySelector('.box_video_social');
    let youreporterElement = document.getElementById('#youreporter');
    this.setLinksHref(boxVideoSocialElement, 'cortv_piuvisti_hp');
    this.setLinksHref(youreporterElement, 'youreporter_hp');
  }

  setLinksHref(container, intcmp) {
    if (container !== null) {
      let elements = Array.from(container.querySelectorAll('.hdr_bkwrapper a'));
      if (elements !== null) {
        elements.forEach(element => {
          let linkPuro = element.getAttribute('href');
          element.setAttribute('href', `${linkPuro}?intcmp=${intcmp}`);
        });
      }
    }
  }
}

module.exports = BoxVideo3Col;



// WEBPACK FOOTER //
// ./src/rcs_cor_hp-lazy-loading/boxes/BoxVideo3Col.js